<template>
  <div class="pcm-b-wrapper" id="pcm-wrapper">
    <div class="pcm-b-topbar">
      <img src="@/assets/images/pc/pageB/logo.webp" alt="" class="pcm-b-logo" />
      <div class="pcm-b-contact-box">
        <img
          v-if="swUrl"
          class="pcm-b-contact"
          @click="toContact(swUrl)"
          src="@/assets/images/pc/pageB/business.png"
          alt=""
        />
        <img
          v-if="tgUrl"
          class="pcm-b-contact"
          @click="toContact(tgUrl)"
          src="@/assets/images/pc/pageB/official.png"
          alt=""
        />
        <img
          v-if="qdUrl"
          class="pcm-b-contact"
          @click="toContact(qdUrl)"
          src="@/assets/images/pc/pageB/channel.png"
          alt=""
        />
      </div>
    </div>
    <img
      src="@/assets/images/pc/pageB/slogan.webp"
      alt=""
      class="pcm-b-slogan"
    />
    <div class="pcm-b-code-box">
      <img class="pcm-b-qrcode" :src="qrImg" alt="" />
    </div>
  </div>
</template>

<script>
import autofit from "autofit.js";

export default {
  props: ["qrImg", "configs", "version", "ip", "switchData"],
  data() {
    return {
      tgUrl: "",
      potatoUrl: "",
      swUrl: "",
      qdUrl: ""
    };
  },
  watch: {
    configs: {
      immediate: true,
      handler(newValue) {
        this.applyConfigs(newValue || []);
      }
    }
  },
  mounted() {
    autofit.init(
      {
        dh: 1080,
        dw: 1920,
        el: "#pcm-wrapper",
        resize: true
      },
      false
    );
  },
  methods: {
    applyConfigs(configs) {
      this.tgUrl = "";
      this.potatoUrl = "";
      this.swUrl = "";
      this.qdUrl = "";

      configs.forEach(item => {
        if (item.configType == "tg_group") {
          this.tgUrl = item.link;
        } else if (item.configType == "potato_group") {
          this.potatoUrl = item.link;
        } else if (item.configType == "sw_cooperate") {
          this.swUrl = item.link;
        } else if (item.configType == "qd_cooperate") {
          this.qdUrl = item.link;
        }
      });
    },
    toContact(url) {
      window.open(url);
    }
  }
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}

.pcm-b-wrapper {
  width: 1920px;
  height: 1080px;
  overflow: hidden;
  position: relative;
  background: url("./../../../assets/images/pc/pageB/bg.webp") no-repeat center;
  background-size: 100% 100%;

  .pcm-b-topbar {
    position: absolute;
    top: 13px;
    left: 39px;
    right: 39px;
    height: 79px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 20;
  }

  .pcm-b-logo {
    height: 79px;
    width: auto;
    object-fit: contain;
  }

  .pcm-b-contact-box {
    display: flex;
    gap: 16px;
    img {
      height: 58px;
      width: auto;
      object-fit: contain;
      cursor: pointer;
      transition: opacity 0.2s;
      &:hover {
        opacity: 0.85;
      }
    }
  }

  .pcm-b-slogan {
    position: absolute;
    top: 230px;
    left: 74px;
    width: 1287px;
    height: 601px;
    z-index: 8;
    pointer-events: none;
  }

  .pcm-b-code-box {
    width: 609px;
    height: 216px;
    background: url("./../../../assets/images/pc/pageB/qrPanel.webp") no-repeat
      center;
    background-size: 100% 100%;
    position: absolute;
    top: 830px;
    left: 324px;
    z-index: 10;

    .pcm-b-qrcode {
      width: 155px;
      height: 155px;
      position: absolute;
      top: 30px;
      left: 30px;
    }
  }
}
</style>
